import { createEntityAdapter } from "@reduxjs/toolkit";
import { apiSlice } from "../../app/api/apiSlice";

const employeeAdapter = createEntityAdapter({
    selectId: (employee) => employee.employeeId,
    sortComparer: (a, b) => b.employeeId - a.employeeId
})

const initialState = employeeAdapter.getInitialState()

export const extendedApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getAllEmployees: builder.query({
            query: () => `/Employee`,
            transformResponse: responseData => {
                return employeeAdapter.setAll(initialState, responseData)
            },
            providesTags: (result, error, arg) => [
                { type: 'Employee', id: "LIST" },
                ...result.ids.map(id => ({ type: 'Employee', id })),
            ]
        }),
    })
})

export const {
    useGetAllEmployeesQuery,
} = extendedApiSlice